import React from "react";
import {Link,Outlet} from "react-router-dom"
import AnimatedText from "./The-3D-texts";
import Footer from "./Footer";
import TotheTop from "./BacktoTop";



const Home = () => {
  return(
  <div className="text-white pt-10">
    <div className="relative mb-24">
    
      <nav className="flex justify-between">
        <Link to="/" className="m-4 text-slate-100 text-xl no-underline hover:text-color active:text-red
        -600 focus:text-color">Home</Link>
        <div className="m-4">
        🌴 <Link to="/countries" className="m-4 text-slate-100 text-xl no-underline hover:text-color active:text-red
        -600 focus:text-color">Countries</Link> 🌴 
        </div>
      </nav>
      <div className="grid min-h-[72vh] place-items-center threeD">
     <AnimatedText />
     </div>
     <div className="menue-link">
     <TotheTop  />
     </div>
      <Outlet />
    </div> 
      <Footer />
     </div>
  )
}

export default Home